module.exports = __webpack_public_path__ + "img/thumb_17.8f13fa28.jpg";